<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>AI Config - CMDB Assessment</h1>
        <p class="text-muted">Agentic AI-powered modernization readiness calculations for CMDB applications</p>

        <div style="padding-top: 20px;">
          <modernization-readiness-calculator />
        </div>
      </div>
    </div>
  </section>
</main>
